import FeedItemEditorContainer from './containers/FeedItemEditorContainer'

export default FeedItemEditorContainer
